import PlatformUserProfile from 'core/ovations-api/definitions/PlatformUserProfile';

export const emptyPlatformUserProfile: PlatformUserProfile = {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    userName: '',
    isArchived: true,
    createDate: '',
    platformPermissions: [],
    clientRoles: [],
};
